import * as types from '@/store/mutation-types';

const state = {
  onPublishItem: {
    last: '',
    type: '',
  },
};

const getters = {
  onPublishItem(state) {
    return state.onPublishItem;
  },
};

const mutations = {
  [types.SET_PUBLISH_ITEM](state, { stamp, type }) {
    state.onPublishItem.last = stamp;
    state.onPublishItem.type = type;
  },
};

const actions = {
  async setPublishItem({ commit }, payload) {
    await commit(types.SET_PUBLISH_ITEM, payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/vuex.js